import { render } from "./FinnTotalCounts30DaysRanking.vue?vue&type=template&id=6afb2892"
import script from "./FinnTotalCounts30DaysRanking.vue?vue&type=script&lang=js"
export * from "./FinnTotalCounts30DaysRanking.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__